import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'
import { linkageFromResource } from '@opallabs/json-api'
import { blockResourceFactory } from './block'

type BlockCustomFieldValueResourceV3 = OpalApiComponent<
  'V3',
  'block_custom_field_value'
>

export const blockCustomFieldValueResourceFactory: Factory<BlockCustomFieldValueResourceV3> =
  Factory.define<BlockCustomFieldValueResourceV3>(() => {
    return {
      id: uuidV4(),
      type: 'block_custom_field_value',
      attributes: {
        value: { value: '' },
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      },
      relationships: {
        block: linkageFromResource(blockResourceFactory.build()),
        custom_field: {
          data: { id: uuidV4(), type: 'custom_field' },
        },
      },
    } satisfies BlockCustomFieldValueResourceV3
  })
